import axios from "axios";
import { API_DETAILS } from "../App";

/*
 * The waitlist for people outside the states Youro serves.
 *
 * These are prospects, not patients: nothing here touches the patient tables,
 * sign-in or the session, and the payload is only what the form asks for —
 * state, an optional zip code, an email only when the person asked to be
 * emailed, and whether they did. The backend (WaitlistController) keeps the
 * email only with that consent, and records what was agreed and when.
 */
export const WAITLIST_PATH = "/waitlist";

const waitlistUrl = (path = "") =>
  API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + WAITLIST_PATH + path;

export function buildWaitlistPayload({ state, zip, email, wantsNotification }) {
  const payload = { state, wantsNotification: Boolean(wantsNotification) };
  const trimmedZip = (zip || "").trim();
  if (trimmedZip) payload.zip = trimmedZip;
  // Only with consent: an address typed and then un-ticked is not sent.
  if (wantsNotification && (email || "").trim()) payload.email = email.trim();
  return payload;
}

export async function submitWaitlist(fields) {
  const res = await axios.post(waitlistUrl(), buildWaitlistPayload(fields));
  return res.data;
}

/** From the link in a waitlist email. The server answers the same for any token. */
export async function unsubscribeWaitlist(token) {
  const res = await axios.post(waitlistUrl("/unsubscribe"), { token });
  return res.data;
}
